import { ShieldStatus } from 'App/ServiceContinuity/types';
import {
	EventMode,
	ShieldSupportabilityPayload,
} from 'Workspace/TelemetryEvents/shieldSupportability/createShieldSupportabilityCASReporter';

export const getShieldSupportabilityAnalyticsPayload = (
	shieldStatus: ShieldStatus,
	eventMode = EventMode.MANUAL
): ShieldSupportabilityPayload => ({
	activeLeases: shieldStatus.activeLeases?.length || 0,
	expiringLeases: shieldStatus.expiringLeases?.length || 0,
	expiredLeases: shieldStatus.expiredLeases?.length || 0,
	missingLeases: shieldStatus.missingLeases?.length || 0,
	eventMode,
});
